import React from "react";
import LiveOrder from "components/atoms/LiveOrders";

const LiveOrders = () => {
  return <LiveOrder />;
};

export default LiveOrders;
